import { Component, inject, OnInit, signal } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import { ApiResult } from '../../../shared/models/api-result.model';
import { DashboardSummary } from '../../models/dashboard.model';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TagStatusComponent } from '../../../shared/components/tag-status/tag-status.component';
import { ToastModule } from 'primeng/toast';
import { TimeFromNowPipe } from '../../../shared/pipes/time-from-now.pip';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-dashboard',
  imports: [
    CurrencyPipe,
    RouterLink,
    ButtonModule,
    TagStatusComponent,
    ToastModule,
    TimeFromNowPipe,
  ],
  templateUrl: './dashboard.component.html',
  styles: `
    .card {
      margin-bottom: 0 !important;
      border-radius: 10px;
      box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.06);
    }
  `,
})
export class DashboardComponent implements OnInit {
  private dashboardService = inject(DashboardService);
  private messageService = inject(MessageService);

  dashboardSummaryData = signal<DashboardSummary | null>(null);

  ngOnInit(): void {
    this.dashboardService.getSummary().subscribe({
      next: (response: ApiResult) => {
        const data = response.data as DashboardSummary;
        this.dashboardSummaryData.set(data);
      },
      error: (e) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Falha',
          detail: 'Ocorreu um erro ao carregar os dados do Dashboard',
          life: 3000,
        });
      },
    });
  }
}
